import React from 'react';
import dayjs from 'dayjs';
import MissingValue from './MissingValue';
import { ageLabel } from './DocCell';

/** Date with a relative line under it ("tomorrow", "3 days ago"). Overdue (past + `dueDate`) turns red. */
export interface DateCellProps {
  value?: string | Date | null;
  /** When true the date is a deadline: past dates render red. */
  dueDate?: boolean;
  /** Suppress the red even if past (e.g. document already closed). */
  settled?: boolean;
  withTime?: boolean;
  compact?: boolean;
  missingLabel?: string;
}

const DateCell: React.FC<DateCellProps> = ({ value, dueDate, settled, withTime, compact, missingLabel }) => {
  if (!value) return <MissingValue label={missingLabel ?? 'no date'} compact={compact} />;
  const d = dayjs(value);
  const overdue = dueDate && !settled && d.startOf('day').isBefore(dayjs().startOf('day').add(1, 'day'));
  const color = overdue ? '#b42323' : undefined;
  return (
    <div style={{ lineHeight: 1.35, fontVariantNumeric: 'tabular-nums', color }}>
      <span style={{ whiteSpace: 'nowrap' }}>{d.format(withTime ? 'D MMM HH:mm' : 'D MMM YYYY')}</span>
      {!compact ? (
        <span style={{ display: 'block', fontSize: 11.5, color: overdue ? '#b42323' : '#8a94a6', whiteSpace: 'nowrap', marginTop: 1 }}>
          {ageLabel(value)}
        </span>
      ) : null}
    </div>
  );
};

export default DateCell;
